import { useTranslation } from "react-i18next";
import { useAxios } from "../useAxios"
import { useQuery } from "@tanstack/react-query";
import { ExamPeriod } from "@types";

export const useGetExamPeriodById = (id?: string) => {

    const axios = useAxios();
    const { t } = useTranslation();

    const getExamPeriodById = async () => {
        try {
            const response = await axios.get<ExamPeriod>(`/api/examterms/${id}`);
            return response.data;
        } catch (error) {
            throw new Error(t("messages.error.getExamPeriod"));
        }
    }

    return useQuery({queryKey: ["examPeriods", id] , queryFn: getExamPeriodById, enabled: !!id});
}